<!-- 刷三防漆 -->
<template>
  <BaseFormItem
    class="need_conformal_coating"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <BaseRadioGroup v-model="val.need_conformal_coating" @change="() => handleChange('need_conformal_coating')">
      <el-radio-button
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>
    <template v-if="val.need_conformal_coating !== 0">
      <BaseCheckbox 
        class="need_conformal_coating__checkbox" 
        v-model="val.is_dodge_solder_joint"
        :true-label="1"
        :false-label="0"
        @change="() => handleChange('is_dodge_solder_joint')"
      >
        规避元器件和区域
      </BaseCheckbox>
      <BaseTipPopover :content="`
          行业规范：大功率带散热面或散热器元件、功率电阻、功率二极管、水泥电阻、金属化螺孔两面、铆接螺母上端面及外表、端子排、线端子、短路器、IC座及插在IC座上的IC、蜂鸣器、传感器、LED、LCD、电池、金边、金手指、测试点，所有类型插座、排针、接线端子及DB头<span style='color: #E6A23C;'>不能刷三防漆。</span>\n
          <span style='color: #E6A23C;'>超出以上列举的内容，还有其他需要规避的元器件和区域，请勾选并备注</span>
        `" 
      />
    </template>
    <!-- 加工要求 -->
    <div v-show="val.need_conformal_coating !== 0 && val.is_dodge_solder_joint" class="need_conformal_coating__remark">
      <i :class="['need_conformal_coating__remark__linker', `linker_${val.need_conformal_coating}`]"></i>
      <!-- 收起状态 -->
      <el-collapse-transition>
        <div v-show="isFold" class="need_conformal_coating__remark__isFold">
          <p>
            三防漆其它加工要求：<span :title="val.need_conformal_coating_remark">{{ val.need_conformal_coating_remark }}</span>
          </p>
          <BaseButton type="default" round @click="() => isFold = false">
            展开备注
            <i class="el-icon-arrow-down"></i>
          </BaseButton>
        </div>
      </el-collapse-transition>
      <!-- 展开状态 -->
      <el-collapse-transition>
        <div v-show="!isFold">
          <p class="need_conformal_coating__remark__label">
            <i>*</i> 加工要求
          </p>
          <BaseInput
            v-model="val.need_conformal_coating_remark"
            type="textarea"
            width="100%"
            resize="none"
            placeholder="如需要规避测试点，请提供涂覆图示"
            maxlength="200"
            show-word-limit
            :rows="3"
            @input="() => handleEmit('need_conformal_coating_remark')"
          />
          <div class="need_conformal_coating__remark__upload">
            <UploadAnnex 
              :fileUrl="val.file_conformal_url"
              :fileName="val.file_conformal_name"
              @change="handleUploadChange"
            />
          </div>
          <div class="need_conformal_coating__remark__btn">
            <BaseTextButton @click="() => isFold = true">
              收起
              <i class="el-icon-arrow-up"></i>
            </BaseTextButton>
          </div>
        </div>
      </el-collapse-transition>
    </div>
  </BaseFormItem>
</template>

<script>
// 上传附件
import UploadAnnex from '../components/uploadAnnex'

import { getSMTFields } from '@@/utils/getFields'

export default {
  props: {
    // 三防漆
    need_conformal_coating: {
      type: Number,
      default: 0
    },
    // 规避元器件和区域
    is_dodge_solder_joint: {
      type: Number,
      default: 0
    },
    // 三防漆加工要求
    need_conformal_coating_remark: {
      type: String,
      default: ''
    },
    // 三防漆加工要求附件地址
    file_conformal_url: {
      type: String,
      default: ''
    },
    // 三防漆加工要求附件名称
    file_conformal_name: {
      type: String,
      default: ''
    },
  },
  components: {
    UploadAnnex
  },
  data() {
    return {
      isFold: false, // 是否收起
      val: {
        need_conformal_coating: this.need_conformal_coating,
        is_dodge_solder_joint: this.is_dodge_solder_joint,
        need_conformal_coating_remark: this.need_conformal_coating_remark,
        file_conformal_url: this.file_conformal_url,
        file_conformal_name: this.file_conformal_name
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    fields() {
      return getSMTFields('need_conformal_coating')
    }
  },
  watch: {
    need_conformal_coating(newVal) {
      this.val.need_conformal_coating = newVal
    },
    is_dodge_solder_joint(newVal) {
      this.val.is_dodge_solder_joint = newVal
    },
    need_conformal_coating_remark(newVal) {
      this.val.need_conformal_coating_remark = newVal
    },
    file_conformal_url(newVal) {
      this.val.file_conformal_url = newVal
    },
    file_conformal_name(newVal) {
      this.val.file_conformal_name = newVal
    }
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
      this.isShowError(false)
    },
    handleUploadChange(data) {
      const { fileUrl, fileName } = data || {}
      this.val.file_conformal_url = fileUrl || ''
      this.val.file_conformal_name = fileName || ''
      this.handleEmit('file_conformal_url')
      this.handleEmit('file_conformal_name')
    },
    handleChange(key) {
      this.handleEmit(key)
      // 刷单面 || 刷双面 || 勾选规避元器件和区域 时 展开加工要求
      if (this.val[key] > 0) {
        this.isFold = false
      }
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';

.need_conformal_coating {
  .need_conformal_coating__checkbox {
    margin: 0 10px;
  }
  .need_conformal_coating__remark {
    position: relative;
    box-sizing: border-box;
    margin-top: 5px;
    padding: 0 16px;
    width: 560px;
    border-radius: 4px;
    background-color: $--background-hover;
    .need_conformal_coating__remark__linker {
      @include moduleLinkerMixin(15px, vertical, dark);
      position: absolute;
      top: -10px;
      &.linker_4 {
        left: 77px;
      }
      &.linker_3 {
        left: 177px;
      }
      &.linker_2 {
        left: 275px;
      }
    }
    .need_conformal_coating__remark__label {
      padding: 4px 0;
      color: $--color-text-primary;
      >i {
        color: $--color-danger;
      }
    }
    .need_conformal_coating__remark__upload {
      margin-top: 6px;
    }
    .need_conformal_coating__remark__btn {
      padding-bottom: 3px;
      text-align: center;
    }
    .need_conformal_coating__remark__isFold {
      box-sizing: border-box;
      padding: 4px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      >p {
        margin-right: 10px;
        @include ellipsis;
        >span {
          color: #909399;
        }
      }
    }
    ::v-deep {
      .base-button.el-button {
        padding: 0 10px;
        height: 24px;
        line-height: 22px;
      }
    }
  }
}
</style>